import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { instrumentMethod } from '../../tools/instrumentMethod';
import { Observable } from '../../tools/observable';
import { clocksNow } from '../../tools/utils/timeUtils';
import { computeStackTraceFromOnErrorMessage } from '../../tools/stackTrace/computeStackTrace';
import { getGlobalObject } from '../../tools/globalObject';
import { computeRawError, isError } from './error';
import { ErrorSource } from './error.types';
export function trackRuntimeError() {
  return new Observable(function (observer) {
    var handleRuntimeError = function handleRuntimeError(originalError, stackTrace) {
      var rawError = computeRawError({
        stackTrace: stackTrace,
        originalError: originalError,
        startClocks: clocksNow(),
        nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
        source: ErrorSource.SOURCE,
        handling: "unhandled" /* ErrorHandling.UNHANDLED */
      });
      observer.notify(rawError);
    };
    var _instrumentOnError = instrumentOnError(handleRuntimeError),
      stopInstrumentingOnError = _instrumentOnError.stop;
    var _instrumentUnhandledR = instrumentUnhandledRejection(handleRuntimeError),
      stopInstrumentingOnUnhandledRejection = _instrumentUnhandledR.stop;
    return function () {
      stopInstrumentingOnError();
      stopInstrumentingOnUnhandledRejection();
    };
  });
}
export function instrumentOnError(callback) {
  return instrumentMethod(getGlobalObject(), 'onerror', function (_ref) {
    var _ref$parameters = _slicedToArray(_ref.parameters, 5),
      messageObj = _ref$parameters[0],
      url = _ref$parameters[1],
      line = _ref$parameters[2],
      column = _ref$parameters[3],
      errorObj = _ref$parameters[4];
    var stackTrace;
    if (!isError(errorObj)) {
      stackTrace = computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
    }
    callback(errorObj !== null && errorObj !== void 0 ? errorObj : messageObj, stackTrace);
  });
}
export function instrumentUnhandledRejection(callback) {
  return instrumentMethod(getGlobalObject(), 'onunhandledrejection', function (_ref2) {
    var _ref2$parameters = _slicedToArray(_ref2.parameters, 1),
      e = _ref2$parameters[0];
    callback(e.reason || 'Empty reason');
  });
}